import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';

import { CertificationCertificateDetails } from './certificate-page.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCertificationCertificate: builder.query<ApiResponse<CertificationCertificateDetails>, string>({
      query: (slug) => ({
        method: 'GET',
        url: `certification/certificate?slug=${slug}`,
      }),
    }),
    getUserHasPassedCertification: builder.query<ApiResponse<boolean>, { certificationExamType: string }>({
      query: ({ certificationExamType }) => ({
        method: 'GET',
        url: `certification/has-passed?certificationExamType=${certificationExamType}`,
      }),
    }),
  }),
});

export const { useGetCertificationCertificateQuery, useGetUserHasPassedCertificationQuery } = extendedApiSlice;
